import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../../../utils/styles';
import { AnalyticsCheckout } from '../../../utils/analytics';
import "./Confirmation.css";
import IconLoop from '../../../assets/svg/nav-icon--loop.svg';
import BackButton from '../../common/BackButton';
import Confirmation from './Confirmation';
import ConfirmationContainer from './ConfirmationContainer';

const Screen = styled.div`
    background: var(--local-page-bg);
    color: var(--local-text-primary);
    height: 100%;
    left: 0;
    overflow-y: auto;
    padding: var(--pad-y) var(--pad-x);
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2000;
`;

const BackLink = styled.div`
    --text-primary: var(--local-text-primary);
`;

const Container = styled.div`
    margin: 2rem auto 1rem;
    max-width: 480px;
`;

const Title = styled.p`
    text-align: center;
    font-family: var(--ff-subtitle);
    font-size: 1.5rem;
    font-weight: 700;
    margin: 1em 0;

    body.theme-platinum & { color: var(--primary); }
`;

const Icon = styled.div`
    background: var(--local-text-primary);
    width: 3rem;
    height: 3rem;
    mask-position: center;
    mask-repeat: no-repeat;
    mask-size: 100%;
    margin: 0 auto;

    body.theme-platinum & { background: var(--primary); }
`;

const PromoContanier = styled.div`
    display: none;
    padding-right: 3rem;
    position: absolute;
    right: -16rem;
    top: 0;
    
    & > img {
        border-radius: 1.5rem;
        height: 25rem;
    }

    @media screen and (min-width: ${breakpoints.desktop}px) {
        display: block;
    }
`;

const BottomText = styled.p`
    font-size: 0.75em;
    margin: 5em auto 0;
    max-width: 780px;
    padding: 0;
    text-align: center;

    & > a {
        color: var(--local-text-primary);
        text-decoration: underline;
    }

    body.theme-platinum &,
    body.theme-platinum & > a {
        color: var(--local-text-primary);
    }

    @media screen and (min-width: ${breakpoints.desktop}px) {
        margin-top: 2.5em;
    }
`

interface Props {
    data: any;
}

class ConfirmationScreen extends React.PureComponent<Props> {
    componentDidMount() {
        const { data } = this.props;
        if (data.tickets || (data.candybar && data.candybar.summary)) {
            AnalyticsCheckout.trackTransaction(data);
        }
    }

    render() {
        const { data } = this.props;

        if (!data) {
            return '';
        }

        const bookingPdfUrl = data.qr ? data.qr.replace('bookingQr', 'bookingPdf').replace(/\.(jpg|png)$/, '.pdf') : '';
        
        return <ConfirmationContainer movie={data.movie}>
            <Screen>
                <BackLink>
                    <BackButton label='Volver a la Cartelera' backTo='/'/>
                </BackLink>

                <Container>        
                    <Icon style={{maskImage: `url(${IconLoop}`}}></Icon>
                    <Title>¡Tu compra ha sido confirmada!</Title>

                    <Confirmation data={data} bookingPdfUrl={bookingPdfUrl} />
                </Container>

                {(data.confirmation_email && bookingPdfUrl) ? <BottomText>
                    Hemos enviado la confirmación de compra y tus boletos a la dirección de correo {data.confirmation_email}.
                    {this.props.data.tickets && <>
                        Si no la recibiste, te recomendamos descargarla haciendo <a href={bookingPdfUrl} target="_blank" rel="noopener noreferrer">clic aquí</a> o
                        en el botón "Descargar" para que puedas ingresar el cine sin hacer filas.
                    </>}
                </BottomText> : ''}
            </Screen>
        </ConfirmationContainer>;
    }

    renderPromo() {
        if (!this.props.data.side_banner) return null;

        return <PromoContanier>
            <img src={this.props.data.side_banner} alt='' />
        </PromoContanier>;
    }
}

export default ConfirmationScreen;